import styled from 'styled-components';
import TimeZoneConnected from '../../components/Common/TimeZone';
import TermSelect from '../components/selects/TermSelect';

export const StyledTimeZone = styled(TimeZoneConnected)`
  margin-top: 10px;
`;

export const StyledTermSelect = styled(TermSelect)`
  width: 96%;
  height: auto;
  margin: 14px 0;
  box-sizing: content-box;
`;
